import styles1 from "../styles/tables";
import styles2 from "../styles/modales";
import React, { useState } from "react";
import Navbar from "../components/navbar";
import { useQuery, useMutation, useQueryClient } from "react-query";
import { getMe } from "../api/users";
import { useNavigate } from "react-router-dom";
import Header from "../components/header";
import Loader from "../components/Loader";
import { getMessageTemplates, updateMessageTemplate } from "../api/roadbook";

const styles = { ...styles1, ...styles2 };

const channelLabels = {
  email: "Email",
  sms: "SMS",
  whatsapp: "WhatsApp",
};

const variablesHelp = {
  reservation_email: "{{client_name}}, {{property_name}}, {{arrival_date}}, {{departure_date}}, {{link}}",
  sms_48h: "{{client_name}}, {{property_name}}, {{arrival_date}}, {{checkin_schedule}}",
};

function Messages() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { data: me } = useQuery("me", () => getMe(navigate));
  const { data: templates, isLoading } = useQuery("message_templates", getMessageTemplates);

  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ subject: "", body: "" });

  const updateMutation = useMutation(({ id, data }) => updateMessageTemplate(id, data), {
    onSuccess: () => {
      queryClient.invalidateQueries("message_templates");
      setEditing(null);
    },
  });

  const handleEdit = (template) => {
    setForm({ subject: template.subject || "", body: template.body || "" });
    setEditing(template.id);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    updateMutation.mutate({ id: editing, data: form });
  };

  return (
    <div style={styles.page}>
      <Header />
      <Navbar page={"messages"} me={me} />
      <div style={styles.SectionInfo}>
        <div style={styles.h1}>
          <span style={styles.h1W}>Templates de messages</span>
        </div>
      </div>

      <div style={{ padding: "0px 200px" }}>
        <div style={{ backgroundColor: "white", borderRadius: 12, padding: 24, boxShadow: "0 2px 8px rgba(0,0,0,0.08)" }}>
          <p style={{ color: "#666", marginBottom: 20 }}>
            Personnalisez les messages envoyés automatiquement aux clients.
          </p>

          {isLoading && <Loader />}
          {templates?.length === 0 && <p>Aucun message</p>}

          {templates && templates.map((template) => (
            <div key={template.id} style={{ marginBottom: 24, padding: 20, border: "1px solid #e0e0e0", borderRadius: 10 }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
                <div>
                  <strong style={{ fontSize: 16 }}>{template.key}</strong>
                  <span style={{ marginLeft: 10, padding: "2px 8px", borderRadius: 4, fontSize: 11, fontWeight: 600, color: "white", backgroundColor: template.channel === "email" ? "#2196F3" : template.channel === "sms" ? "#4CAF50" : "#25D366" }}>
                    {channelLabels[template.channel] || template.channel}
                  </span>
                </div>
                <button onClick={() => handleEdit(template)} style={{ padding: "6px 16px", border: "1px solid #2C5F2D", borderRadius: 6, backgroundColor: "white", color: "#2C5F2D", cursor: "pointer", fontSize: 13 }}>
                  Modifier
                </button>
              </div>

              {editing === template.id ? (
                <form onSubmit={handleSubmit}>
                  {template.channel === "email" && (
                    <div style={{ marginBottom: 12 }}>
                      <label style={{ display: "block", marginBottom: 4, fontWeight: 600, fontSize: 13 }}>Sujet</label>
                      <input type="text" value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} style={{ width: "100%", padding: 8, borderRadius: 6, border: "1px solid #ccc" }} />
                    </div>
                  )}
                  <div style={{ marginBottom: 12 }}>
                    <label style={{ display: "block", marginBottom: 4, fontWeight: 600, fontSize: 13 }}>Contenu</label>
                    <textarea value={form.body} onChange={(e) => setForm({ ...form, body: e.target.value })} style={{ width: "100%", padding: 8, borderRadius: 6, border: "1px solid #ccc", minHeight: 150 }} />
                  </div>
                  <p style={{ fontSize: 12, color: "#888", marginBottom: 12 }}>
                    Variables disponibles : {variablesHelp[template.key] || "Aucune"}
                  </p>
                  <div style={{ display: "flex", gap: 12 }}>
                    <button type="submit" style={{ padding: "6px 16px", backgroundColor: "#2C5F2D", color: "white", border: "none", borderRadius: 6, cursor: "pointer", fontWeight: 600, fontSize: 13 }}>
                      Enregistrer
                    </button>
                    <button type="button" onClick={() => setEditing(null)} style={{ padding: "6px 16px", backgroundColor: "#f0f0f0", color: "#333", border: "none", borderRadius: 6, cursor: "pointer", fontSize: 13 }}>
                      Annuler
                    </button>
                  </div>
                </form>
              ) : (
                <>
                  {template.subject && <p style={{ fontSize: 13, marginBottom: 4 }}><strong>Sujet :</strong> {template.subject}</p>}
                  <div style={{ fontSize: 13, color: "#555", whiteSpace: "pre-wrap", maxHeight: 100, overflow: "hidden" }}>
                    {template.body || <em>Aucun contenu</em>}
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Messages;
